<template>
  <NuxtLayout
    name="generic"
    :header="data?.header"
    :footer="data?.footer"
  >
    <div
      :class="{
        'event-template mt-14 bg-www-color-neutral-off-white md:mt-120px': true,
        'max-md:[&>p.content]:text-sm': true,
      }"
    >
      <template v-if="data">
        <HeroContent
          v-if="data.heroContent"
          v-bind="data.heroContent"
        />

        <SectionBuilder
          v-if="data.content"
          v-bind="data.content"
          :class="{
            'text-www-color-neutral-medium-dark': true,
          }"
        />
      </template>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { queryEvent } from '~/queries/pages/PageEvent.query';
import type { QueryEventResult } from '~/sanity/types';
import HeroContent from '~/components/Atmos/HeroContent/HeroContent.vue';
import SectionBuilder from '~/components/Atmos/SectionBuilder/SectionBuilder.vue';
import { STRUCTURED_DATA_DEFAULTS } from '~/utils/structuredDataDefaults';

const { path: currentPathname } = useRoute();

const { data } = await useWwwSanityQueryNonNull<QueryEventResult>(queryEvent, {
  currentPathname,
});

usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.description,
  ogImage:
    data.value?.ogImage?.asset ||
    data.value?.cardImage?.asset ||
    data.value?.genericCardImage?.asset,
  title: data.value?.htmlTitle || data.value?.title,
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  twitterCard: 'summary',
  structuredData: [
    {
      schemaType: 'Event',
      title: data.value?.htmlTitle || data.value?.title,
      description: data.value?.ogDescription || data.value?.description,
      startDate: data.value?.startDateTime,
      endDate: data.value?.endDateTime,
      locationName: data.value?.location,
      organizerName: STRUCTURED_DATA_DEFAULTS.organization.name,
      organizerUrl: STRUCTURED_DATA_DEFAULTS.organization.url,
      imageRef:
        data.value?.ogImage?.asset?._ref ||
        data.value?.cardImage?.asset?._ref ||
        data.value?.genericCardImage?.asset?._ref,
      enabled: true,
    },
  ],
});
</script>
